import { RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { BaseGrassetto, BaseScatola, BaseGridLayout, formattaImportoMonetario } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import ConfigManager from 'components/config/ConfigManager'
import Sottotitolo from 'components/ui/Sottotitolo'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import Sezione from 'components/ui/Sezione'
import { isPagamentoPagato } from '../utilFrontoffice'
import SpiegoneModalitaPagamento from 'components/ui/SpiegoneModalitaPagamento'
import { FRONTOFFICE_VERBALE_PAGAMENTO } from 'configuration/frontoffice'


const CFG = FRONTOFFICE_VERBALE_PAGAMENTO

export default function SceltaPagamento(props) {
  const {
    codiceAvvisoScelto,
    setCodiceAvvisoScelto,
    pagamenti,
  } = props

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE_PAGAMENTO]}
      render={({ txt }) =>
        <>
          <Titoletto>{txt(CFG.TITOLO)}</Titoletto>
          <Testo sx={{ mb: 3 }}>{txt(CFG.DESCRIZIONE)}</Testo>

          <Sezione>
            <RadioGroup
              value={codiceAvvisoScelto}
              onChange={e => setCodiceAvvisoScelto(e.target.value)}
            >
              <BaseGridLayout vertical>
                {pagamenti.map(pagamento => (
                  <BaseScatola outlined key={pagamento.codice_avviso}>
                    <FormControlLabel
                      value={pagamento.codice_avviso}
                      control={<Radio />}
                      disabled={!pagamento.pagabile}
                      label={<Pagamento pagamento={pagamento} />}
                    />
                  </BaseScatola>
                ))}
              </BaseGridLayout>
            </RadioGroup>
          </Sezione>
          <SpiegoneModalitaPagamento />
        </>
      }
    />
  )
}



export function Pagamento(props) {
  const { pagamento } = props
  const { descrizione, codice_avviso, i: importo } = pagamento
  const cfgImporto = isPagamentoPagato(pagamento) ? CFG.OPZIONE_IMPORTO_PAGATO : CFG.OPZIONE_IMPORTO

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE_PAGAMENTO]}
      render={({ txt }) =>
        <>
          <Testo noMargine>
            <BaseGrassetto><span dangerouslySetInnerHTML={{ __html: descrizione }} /></BaseGrassetto>
          </Testo>
          {/* CONNET NON RITORNA PER ORA tipo E giorni DEL PAGAMENTO */}
          {/* 
          <Testo><BaseGrassetto>{txt(CFG.OPZIONE_TITOLO, { giorni: giorni })}</BaseGrassetto></Testo>
          <Sottotitolo>{txt(tipo === 'ridotto' ? CFG.OPZIONE_IMPORTO_RIDOTTO : CFG.OPZIONE_IMPORTO_ORDINARIO, { giorni: giorni })}</Sottotitolo> 
          */}
          <Sottotitolo>{txt(cfgImporto, { importo: formattaImportoMonetario(importo) })}</Sottotitolo>
          <Sottotitolo>{txt(CFG.OPZIONE_CODICE_AVVISO, { codice_avviso })}</Sottotitolo>
        </>
      }
    />
  )
}